module.exports = __webpack_public_path__ + "img/visalogo.af9ec67a.png";